import { render, staticRenderFns } from "./waterLevelOne.vue?vue&type=template&id=4086ce4e&scoped=true&"
import script from "./waterLevelOne.vue?vue&type=script&lang=js&"
export * from "./waterLevelOne.vue?vue&type=script&lang=js&"
import style0 from "./waterLevelOne.vue?vue&type=style&index=0&id=4086ce4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4086ce4e",
  null
  
)

export default component.exports